module.exports = __webpack_public_path__ + "static/MADECarvingSoft-Black-fec0770eb4b4606e308ba7e911133512.woff";